import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    LinearProgress,
    Stack,
    Typography,
} from '@mui/material';
export default function ImportProgressDialog({ open, progress }) {
    const progressPercent = progress?.total
        ? Math.min(100, Math.round((progress.completed / progress.total) * 100))
        : 0;

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 2, p: 1 } }}
        >
            <DialogTitle>Import läuft</DialogTitle>
            <DialogContent>
                <Stack spacing={1.5}>
                    <LinearProgress
                        variant={progress?.total ? 'determinate' : 'indeterminate'}
                        value={progressPercent}
                    />
                    <Typography variant="body2" color="text.secondary">
                        {progress?.total
                            ? `${progress.completed} von ${progress.total} Schritten`
                            : 'Import wird vorbereitet...'}
                    </Typography>
                    {progress?.phase && (
                        <Typography variant="body2">
                            {progress.phase}
                        </Typography>
                    )}
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
